export default interface Props {
  children: string | any[];
  className?: string;
  disabled?: boolean;
  full?: boolean;
  onClick?: (arg: any) => void;
  type?: 'submit' | 'reset' | 'button';
  'data-title'?: string;
  'data-accesskey'?: string;
  // tslint:disable-next-line
};
